function socketConnect(url, session, browserTabId, init, onConnect, forceNewConnection, feedbackToken) {
  var firstConnect = true;
  if (url.indexOf('https') === -1 && url.indexOf('http') === -1) {
    url = 'https://' + url;
  }
    var socket = io.connect(url, {
        secure : true,
        withCredentials : true,
        reconnection : true,
        'force new connection':forceNewConnection
    });

    socket.on('connect', function() {
    	if(firstConnect){
	        socket.emit('auth', session);
    	}
    	
    });
    
    socket.on('reconnect', function() {
        moveInViewModel.connectionInfo.visible(false);
        moveInViewModel.modalOpen(false);
    	firstConnect=false;
    	clearInterval(checktimeout);
    	
		$.post("/application/index/get-session-token", {} , function(response) {
			response = jQuery.parseJSON(response);
			session = response.session;
			socket.emit('auth', session);
		});
    	
    	if (typeof moveInViewModel !== 'undefined') {
    	    checktimeout = setInterval(moveInViewModel.checkNoActivityTimeOut, 1000 * 60 * 60 * 3);
    	}
    });
    socket.on('disconnect', function(obj) {
        //Enable connection lost information popup
        moveInViewModel.connectionInfo.visible(true);
        moveInViewModel.modalOpen(true);
    });
    socket.on('authed', function() {
        socket.emit('subscribe', {session:session,browserTabId:browserTabId});

        /* load the initial data */        
        if(onConnect){
        	onConnect();
        	onConnect =false;
        }
        __socketIoIsConnected$ = true;
        
        if (init) {
            setTimeout(function() {
            	moveInViewModel.bindDataPromise = moveInViewModel.getPromise();
            	moveInViewModel.configDataPromise = moveInViewModel.getPromise();
                init = false
                url = '/application/index/init';
                /* Send the data using post */
                var posting = $.post(url, {
                    'token' : 'hardToGuess',
                    'browserTabId' : browserTabId

                });

                /* Put the results in a div */
                posting.done(function(data) {
                  
                });
            }, 0);
        	
        }

        if (feedbackToken) {
            url = '/quick-update/feedback/update-feedback';
            /* Send the data using post */
            var posting = $.post(url, {
                'token' : feedbackToken,
                'browserTabId' : browserTabId
            });
        }

        socket.on('response', function(obj) {
            if (obj.functionCall == '') return;
            var cache = typeof obj.cache === 'string' && obj.cache === 'true' ? true : false;
            if (cache) {
                var cacheObj = moveInViewModel.getCache();
                cacheObj.set(obj.cacheKey, obj.data);
            }

            var objects = obj.functionCall.split(/\.|\(\)/),
                callback = window;
            if (objects.length > 1) { // this callback would look like this classname.methodname.somethingelse
                while (objects.length) {
                    callback = callback[objects.shift()] || callback();
                    if (objects.length == 1 && callback[objects[0]]) {
                        
                    	callback[objects[0]](obj.data);
                        
                        return;
                    }
                }
            } else {
                if (window[obj.functionClass || 'responseHandler']) {
                    callback = window[obj.functionClass || 'responseHandler'][obj.functionCall] || false;
                } else {
                    callback = false;
                }
            }

            if (typeof callback === 'function') {
                callback(obj.data);
            } else {
                console.warn(obj.functionClass, obj.functionCall, ' <-- undefined');
            }
        });

    });
}
var login = {

         tokenValidate: function(data){
             data = jQuery.parseJSON(data.message);
             baseView.validToken(data.status);
            },


    failedToken: function(data){
        div = $('<div>').text(jQuery.i18n.prop(data.message));
        $('#login-form .alert.alert-danger').remove();
        div.attr('class', 'alert alert-danger');
        $('#login-form').prepend(div);
    },
    
    resetFailedToken: function(data){
        $('#response-error').remove();
        
        msg = $.trim(data.message);
        msg = jQuery.i18n.prop(msg);
        frmLabel = jQuery.i18n.prop('label_form_not_saved');
        $('#login-form').append('<div class="feedback feedback-warning feedback-error-reset" id="response-error">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' + 
                                            '<h4 class="modal-title">' +
                                                '<i class="icon icon-error"></i>' +
                                                    '<span>' + frmLabel + '</span>' +
                                            '</h4>' +
                                        '</div>' +                                    
                                        '<div class="modal-body">' +
                                            '<div class="panel invalid" id="accordion" role="tablist">' +
                                                '<span class="label" id="alert-msg">' + msg + '</span>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                 '</div>');  
    },
    passwordUpdated : function(data){
        var counter = 3;
        var countdownInterval = 1000,
	    messageRemoveTimeout = 3000;
    	data = jQuery.parseJSON(data.message);
        if (data.status && data.status==1) {
        	$('.js-submitButton').hide();
        	$('#response-error').remove();
            $('.feedback-success').show();
            var redirectInterval = setInterval(function() {
                $('#success_counter').text(counter);
                counter = counter - 1;
            }, countdownInterval);

            setTimeout(function() {
            	clearInterval(redirectInterval);
            	postRedirect('/', {passwordReset:true});
            }, messageRemoveTimeout);
        }
    },

    checkResponse : function(data) {
        data = jQuery.parseJSON(data.message);
        if (data.login == 'success') {
            url = '/application/index/login-validate';
            /* Send the data using post */
            var posting = $.post(url, {
                'token' : 'hardToGuess',
                loginToken : data.token,
                //userID : data.user.id,
                //userName : data.user.username,
                browserTabId : browserTabId
                //defaultLanguage : data.user.defaultLanguage
            });

            /* Put the results in a div */
            posting.done(function(data) {
                data = JSON.parse(data);
                if (data.status == 'success') {
                	var checkPagerId = window.location.href.split('#'); // check if there pre url exits then dont move to landingPage after login.
                    localStorage.removeItem('visitedLinks');
                    localStorage.removeItem('browserNotification')
                    var keys = Object.keys(localStorage);
                    for (var i = 0; i < keys.length; i++) {
                    	if (keys[i].indexOf('recent-') !== -1) {
                    		localStorage.removeItem(keys[i])
                    	}
                    }
                    if (typeof(data.landingPage) == 'undefined' || data.landingPage == '' || (data.landingPage.length < 2)) {
                        window.location.href = '/';
                    } else {
                    	window.location.href = checkPagerId.length > 1 ? '/' : '/' + data.landingPage;
                    }
                    window.location.reload();
                } else {
                    div = $('<span>').text(jQuery.i18n.prop('message_error'));
                    div.attr('class', 'class="text-block"');
                    $('#login-form').find(".js-warnings .js-panel").html('');
                    $('#login-form').find(".js-warnings .js-panel").append(div);
                    $('#login-form').find(".js-warnings").show();
                }
            });
        } else {
            if (typeof data.action !== 'undefined' && data.action === 'reset') {
                window.location.href = '/reset/'+data.token;
            }
            div = $('<span>').text(jQuery.i18n.prop(data.message));
            div.attr('class', 'class="text-block"');
            //Remove Old Error Message Div.
            $('#login-form').find(".js-warnings .js-panel").html('');
            $('#login-form').find(".js-warnings .js-panel").append(div);
            $('#login-form').find(".js-warnings").show();
        }

    },
    
    checkLoginResponse : function(data) {
        data = jQuery.parseJSON(data.message);
        moveInViewModel.loginBox.loading(false);
        if (data.login == 'success') {
            url = '/application/index/login-validate';
            /* Send the data using post */
            var posting = $.post(url, {
                'token' : 'hardToGuess',
                //userID : data.user.id,
                //userName : data.user.username,
                loginToken : data.token,
                browserTabId : browserTabId
                //defaultLanguage : data.user.defaultLanguage
            });

            /* Put the results in a div */
            posting.done(function(data) {

            	data = JSON.parse(data);
                if (data.status == 'success') {
                    moveInViewModel.loginBox.visible(false);
                    moveInViewModel.modalOpen(false);
                	checktimeout = setInterval(moveInViewModel.checkNoActivityTimeOut, 1000 * 60 * 60 * 3 ); // 3hours
                } else {
                    
                    moveInViewModel.loginBox.message({
                        required: [],
                        invalid: [{
                            label: moveInViewModel.translate('message_error'),
                            index: '.js-pass',
                            event: function() {
                            },
                        }]
                    });
                    moveInViewModel.loginBox.errorList.push('invalidPassword');
                    moveInViewModel.loginBox.showError(true);
                    
                }
            });

        } else {

            
            moveInViewModel.loginBox.message({
                required: [],
                invalid: [{
                    label: moveInViewModel.translate(data.message),
                    index: '.js-pass',
                    event: function() {
                    },
                }]
            });
            moveInViewModel.loginBox.errorList.push('invalidPassword');
            moveInViewModel.loginBox.showError(true);
        }

    },
    sendNotification: function (data) {
        data = jQuery.parseJSON(data.message);
        var actionLogId = data.actionLogId;
        window.setTimeout(function(){
            var browserNotification = [];
            if (localStorage.getItem("browserNotification")) {
                browserNotification = localStorage.getItem("browserNotification");
                browserNotification = JSON.parse(browserNotification);
            }

            if (browserNotification.indexOf(actionLogId) === -1) {
                browserNotification.push(actionLogId);
                browserNotification = JSON.stringify(browserNotification);
                localStorage.setItem("browserNotification",browserNotification);
                notifyUser(data);
            }
        }, Math.random() * 100);
    }
};

var systemFunctions = {
        logout : function() {
            // js code to change url of window to login screen
            window.location = '/';
        },
        
        onlyLogout : function() {
            // js code to change url of window to login screen
        	return false;
        }
    };

var quickUpdate = {
        feedbackCallback: function(data) {
            data = jQuery.parseJSON(data.message);
            if(data.status == 1) {
                if (data.response == 8622) {
                    window.location = '/quick-update/feedback/success-yes';
                } else {
                    window.location = '/quick-update/feedback/success-no';

                }
            } else {
                window.location = '/quick-update/feedback/error';
            }
        },
        unsubscribeCallback: function(data) {
            data = jQuery.parseJSON(data.message);
            if (data.headerImage) {
                var imageFileId = data.headerImageData.fileStorageId;
                window.location = '/quick-update/unsub/success?hId=' + imageFileId;
            }else{
                window.location = '/quick-update/unsub/success';
            }
        }
};

function request(path, data) {

    postData = {
        'browserTabId' : browserTabId
    };

    if (data) {
        var postData = $.extend(postData, data);
    }
    $.post(path, postData);


}

ko.bindingHandlers.i18nTranslateText = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
               var param1 = valueAccessor(); // not used, but could be used.
               $(element).html(jQuery.i18n.prop(param1));
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            // At this point your language have change, update all labels
        }
    };
function postRedirect(path, parameters) {
    var form = $('<form></form>');

    form.attr("method", "post");
    form.attr("action", path);

    $.each(parameters, function(key, value) {
        var field = $('<input></input>');

        field.attr("type", "hidden");
        field.attr("name", key);
        field.attr("value", value);

        form.append(field);
        
        
    });

    // The form needs to be a part of the document in
    // order for us to be able to submit it.
    $(document.body).append(form);
    form.submit();
}
